import { API } from "aws-amplify";

export default async function getAccountStatus() {
  return await API.get("general-info", "/get-account-details", {
    // queryStringParameters: {
    //   tenantId: id,
    // },
  });
}
